<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

// Auto-save cart note functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log('Custom JS is loaded!');
  
  const cartNoteField = document.getElementById('cart-note');
  
  if (cartNoteField) {
    console.log('Cart note field found!');
    let saveTimeout;
    
    // Auto-save when customer stops typing
    cartNoteField.addEventListener('input', function() {
      console.log('User is typing in cart note field');
      // Clear previous timeout
      clearTimeout(saveTimeout);
      
      // Set new timeout to save after 1 second of no typing
      saveTimeout = setTimeout(function() {
        console.log('Attempting to save cart note:', cartNoteField.value);
        // Update cart note via AJAX
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            note: cartNoteField.value
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Cart note auto-saved successfully');
          // Show a subtle indicator that it's saved
          cartNoteField.style.borderColor = '#28a745';
          setTimeout(function() {
            cartNoteField.style.borderColor = '';
          }, 1000);
        })
        .catch(error => {
          console.error('Error saving cart note:', error);
        });
      }, 1000);
    });
  } else {
    console.log('Cart note field not found');
  }
});


<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
